import React from 'react';
import { string } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

const ActionBox = ({ icon, text }) => (
  <div style={styles.container}>
    <div style={styles.content}>
      <img src={icon} alt="" style={styles.icon} />
      <UTLabel bold style={styles.text}>
        {text}
      </UTLabel>
    </div>
  </div>
);

ActionBox.propTypes = {
  icon: string.isRequired,
  text: string.isRequired
};

export default ActionBox;
